<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb" style="align-items:center;">
        <BackButton
          :style="$route.name.includes('Home') ? 'display:none;' : ''"
        />
        <li
          class="breadcrumb-item pb-1"
          aria-current="page"
          v-for="(routeObject, index) in newRouteHistory"
          :key="index"
        >
          <span
            v-if="isLast(index)"
            class="d-inline-flex align-items-start position-relative color-teal"
            >{{ getName(routeObject, "name") }}
            &nbsp;
            <span
              v-if="
                routeObject.module_id && checkFavourite(routeObject.module_id)
              "
              class="icon-star icon-star-fill"
              @click="hotPickModule(routeObject.module_id)"
              v-b-tooltip.hover
              :title="`Remove from Favourite`"
            ></span>
            <span
              v-if="
                routeObject.module_id && !checkFavourite(routeObject.module_id)
              "
              class="icon-star icon-star-empty"
              @click="hotPickModule(routeObject.module_id)"
              v-b-tooltip.hover
              :title="`Add to Favourite`"
            ></span>
          </span>

          <!-- -->
          <!-- Temp Removed breadcrumb -->
          <!-- Add back below two function -->
          <!-- @click.native="setCurrentSideNavRoute(getName(routeObject,'path'))" -->
          <!-- :to="routeObject" -->
          <router-link v-else :to="getName(routeObject, 'path') || '/'">{{
            getName(routeObject, "name")
          }}</router-link>
        </li>
      </ol>
    </nav>

    <!--- v-if="
        $route.name.includes('Add') ||
          $route.name.includes('Edit') ||
          $route.name === 'Transactions' ||
          $route.name.includes('Vouchers Usage') ||
          $route.name === 'Drag & Drop Schedule'
      "
  ----->
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import BackButton from "@/components/UIElements/BackButton.vue";
  import Nav from "@/Nav";

  export default {
    components: { BackButton },

    props: {
      list: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
    data() {
      return {
        SideNav: Nav.items,
      };
    },
    computed: {
      isGoGoCinema() {
        let isGogoCinema =
          this.$store.getters.isGogoCinema == "Y" ? true : false;
        return isGogoCinema;
      },
      ...mapGetters(["getHotPickModules"]),
      routeRecords: function() {
        return this.list.filter((route) => {
          return route.name;
        });
      },
      newRouteHistory() {
        this.routeRecords.forEach((x) => {
          if (this.isGoGoCinema && x.name == "My Cinemas") {
            x["name"] = "On Demand";
          }
          this.SideNav.forEach((y) => {
            y.children.forEach((z) => {
              if (z.hasOwnProperty("children") && z.children.length > 0) {
                z.children.forEach((w) => {
                  if (w.url.toLowerCase() == x.path.toLowerCase()) {
                    x["module_id"] = w.module_id || 0;
                    if (this.isGoGoCinema && w.hasOwnProperty("GogoName")) {
                      x["name"] = w.GogoName;
                    }
                  }
                });
              } else {
                if (z.url.toLowerCase() == x.path.toLowerCase()) {
                  x["module_id"] = z.module_id || 0;
                  if (this.isGoGoCinema && z.hasOwnProperty("GogoName")) {
                    x["name"] = z.GogoName;
                  }
                }
              }
            });
          });
        });
        return this.routeRecords;
      },
    },
    methods: {
      ...mapActions(["setCurrentSideNavRoute", "hotPickModule"]),
      checkFavourite(module_id) {
        let TempArr = [];
        TempArr = this.getHotPickModules.filter(
          (x) => x.module_id == module_id
        );
        if (TempArr.length > 0) {
          return true;
        } else {
          return false;
        }
      },
      getName: function(item, type) {
        return item[type] && item[type].length > 0 ? item[type] : null;
      },
      isLast: function(index) {
        return index === this.list.length - 1;
      },
    },
  };
</script>
<style>
  .pointer-none {
    cursor: no-drop;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Containers/breadcrumb.vue